var map = {
	"./": "176d",
	"./dpc": "ab15",
	"./dpc.js": "ab15",
	"./dpd": "5f80",
	"./dpd.js": "5f80",
	"./dpp": "3951",
	"./dpp.js": "3951",
	"./dpw": "59f1",
	"./dpw.js": "59f1",
	"./index": "176d",
	"./index.js": "176d",
	"./korsak": "3bde",
	"./korsak.js": "3bde",
	"./saksi": "21a4",
	"./saksi.js": "21a4",
	"./sys_admin": "e38d",
	"./sys_admin.js": "e38d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6c33";